import gaEventTracker, { events } from "util/gaEventTracker";

export const types = {
    COMPANY_SEARCH_REQUEST: "servicePayments/COMPANY_SEARCH_REQUEST",
    COMPANY_SEARCH_SUCCESS: "servicePayments/COMPANY_SEARCH_SUCCESS",
    COMPANY_SEARCH_FAILURE: "servicePayments/COMPANY_SEARCH_FAILURE",

    PAYMENT_MODES_REQUEST: "servicePayments/PAYMENT_MODES_REQUEST",
    PAYMENT_MODES_SUCCESS: "servicePayments/PAYMENT_MODES_SUCCESS",
    PAYMENT_MODES_FAILURE: "servicePayments/PAYMENT_MODES_FAILURE",

    SERVICE_BILLING_REQUEST: "servicePayments/SERVICE_BILLING_REQUEST",
    SERVICE_BILLING_SUCCESS: "servicePayments/SERVICE_BILLING_SUCCESS",
    SERVICE_BILLING_FAILURE: "servicePayments/SERVICE_BILLING_FAILURE",

    PREPARE_PAYMENT_REQUEST: "servicePayments/PREPARE_PAYMENT_REQUEST",
    PREPARE_PAYMENT_SUCCESS: "servicePayments/PREPARE_PAYMENT_SUCCESS",
    PREPARE_PAYMENT_FAILURE: "servicePayments/PREPARE_PAYMENT_FAILURE",

    PAY_SERVICE_REQUEST: "servicePayments/PAY_SERVICE_REQUEST",
    PAY_SERVICE_SUCCESS: "servicePayments/PAY_SERVICE_SUCCESS",
    PAY_SERVICE_FAILURE: "servicePayments/PAY_SERVICE_FAILURE",

    CLEAN_SERVICE_TICKET: "servicePayments/CLEAN_SERVICE_TICKET",
    SET_PREPARE_DATA: "servicePayments/SET_PREPARE_DATA",
    RESET_PAYMENT_FORM: "servicePayments/RESET_PAYMENT_FORM",

    EXPIRATION_AGENDA_BILLS_REQUEST: "servicePayments/EXPIRATION_AGENDA_BILLS_REQUEST",
    EXPIRATION_AGENDA_BILLS_SUCCESS: "servicePayments/EXPIRATION_AGENDA_BILLS_SUCCESS",
    EXPIRATION_AGENDA_BILLS_FAILURE: "servicePayments/EXPIRATION_AGENDA_BILLS_FAILURE",

    SCHEDULED_BILL_REQUEST: "servicePayments/SCHEDULED_BILL_REQUEST",
    SCHEDULED_BILL_SUCCESS: "servicePayments/SCHEDULED_BILL_SUCCESS",
    SCHEDULED_BILL_FAILURE: "servicePayments/SCHEDULED_BILL_FAILURE",

    VOUCHER_REQUEST: "servicePayments/VOUCHER_REQUEST",
    VOUCHER_SUCCESS: "servicePayments/VOUCHER_SUCCESS",
    VOUCHER_FAILURE: "servicePayments/VOUCHER_FAILURE",

    SET_SELECTED_COMPANY: "servicePayments/SET_SELECTED_COMPANY",
    CLEAR_COMPANY: "servicePayments/CLEAR_COMPANY",
};

export const INITIAL_STATE = {
    fetchingCompanies: false,
    companies: [],
    message: "",
    selectedCompany: {
        companyCode: "",
        companyName: "",
        paymentModes: [],
        fetchingModes: false,
    },
    fetchingBilling: false,
    billingList: [],
    prepareData: {},
    fetching: false,
    servicePaymentTicket: { status: "", idTransaction: "" },
    debts: [],
    scheduledBill: {},
    voucherData: [],
};

export default (state = INITIAL_STATE, action = {}) => {
    const {
        companies,
        message,
        companyCode,
        paymentModes,
        billingList,
        prepareData,
        servicePaymentTicket,
        debts,
        scheduledBill,
        selectedCompany,
        voucherData,
    } = action;

    switch (action.type) {
        case types.COMPANY_SEARCH_REQUEST:
            return {
                ...state,
                fetchingCompanies: true,
            };
        case types.COMPANY_SEARCH_SUCCESS:
            return {
                ...state,
                companies,
                fetchingCompanies: false,
            };
        case types.COMPANY_SEARCH_FAILURE:
            return {
                ...state,
                message,
                fetchingCompanies: false,
            };
        case types.PAYMENT_MODES_REQUEST:
            return {
                ...state,
                selectedCompany: {
                    ...state.selectedCompany,
                    fetchingModes: true,
                },
            };
        case types.PAYMENT_MODES_SUCCESS:
            return {
                ...state,
                selectedCompany: {
                    ...state.selectedCompany,
                    companyCode,
                    paymentModes,
                    fetchingModes: false,
                },
            };
        case types.PAYMENT_MODES_FAILURE:
            return {
                ...state,
                message,
                selectedCompany: {
                    ...state.selectedCompany,
                    fetchingModes: false,
                },
            };
        case types.SERVICE_BILLING_REQUEST:
            return {
                ...state,
                fetchingBilling: true,
            };
        case types.SERVICE_BILLING_FAILURE:
            return {
                ...state,
                message,
                fetchingBilling: false,
            };
        case types.SERVICE_BILLING_SUCCESS:
            return {
                ...state,
                billingList,
                fetchingBilling: false,
            };
        case types.PREPARE_PAYMENT_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.PREPARE_PAYMENT_FAILURE:
            return {
                ...state,
                message,
                fetching: false,
            };
        case types.PREPARE_PAYMENT_SUCCESS:
            return {
                ...state,
                prepareData,
                fetching: false,
            };
        case types.PAY_SERVICE_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.PAY_SERVICE_SUCCESS:
            return {
                ...INITIAL_STATE,
                servicePaymentTicket,
                fetching: false,
            };
        case types.PAY_SERVICE_FAILURE:
            return {
                ...state,
                message,
                fetching: false,
            };
        case types.CLEAN_SERVICE_TICKET:
            return {
                ...state,
                servicePaymentTicket: { status: "", idTransaction: "" },
            };

        case types.SET_PREPARE_DATA:
            return {
                ...state,
                prepareData,
            };
        case types.RESET_PAYMENT_FORM:
            return {
                ...INITIAL_STATE,
            };
        case types.EXPIRATION_AGENDA_BILLS_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.EXPIRATION_AGENDA_BILLS_SUCCESS:
            return {
                ...state,
                debts,
                fetching: false,
            };

        case types.EXPIRATION_AGENDA_BILLS_FAILURE:
            return {
                ...state,
                message,
                fetching: false,
            };

        case types.VOUCHER_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.VOUCHER_SUCCESS:
            return {
                ...state,
                voucherData,
                fetching: false,
            };
        case types.VOUCHER_FAILURE:
            return {
                ...state,
                message,
                fetching: false,
            };

        case types.SCHEDULED_BILL_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.SCHEDULED_BILL_SUCCESS:
            return {
                ...state,
                scheduledBill,
                fetching: false,
            };

        case types.SCHEDULED_BILL_FAILURE:
            return {
                ...state,
                message,
                fetching: false,
            };
        case types.SET_SELECTED_COMPANY:
            return {
                ...state,
                selectedCompany: {
                    ...selectedCompany,
                    paymentModes: [],
                    fetchingModes: state.selectedCompany.fetchingModes,
                },
                billingList: [],
            };
        case types.CLEAR_COMPANY:
            return {
                ...state,
                selectedCompany: {
                    ...INITIAL_STATE.selectedCompany,
                },
                billingList: [],
            };
        default:
            return state;
    }
};

export const actions = {
    searchCompany: (searchString) => ({
        type: types.COMPANY_SEARCH_REQUEST,
        searchString,
    }),
    getPaymentModes: (companyCode) => ({
        type: types.PAYMENT_MODES_REQUEST,
        companyCode,
    }),
    getServiceInvoices: (invoiceParams) => ({
        type: types.SERVICE_BILLING_REQUEST,
        invoiceParams,
    }),
    preparePayment: (prepareData) => ({
        type: types.PREPARE_PAYMENT_REQUEST,
        prepareData,
    }),
    payService: (paymentData, formikBag, credentialType) => {
        // gaEventTracker.triggerEvent(events.cuentas_pagar_servicios());

        gaEventTracker.triggerEvent(events.pagoServicio_pagar({ empresa: paymentData.companyCode }));
        gaEventTracker.triggerEvent(events.pagos_pagar_firmar());
        return {
            type: types.PAY_SERVICE_REQUEST,
            paymentData,
            formikBag,
            credentialType,
        };
    },
    cleanServiceTicket: () => ({
        type: types.CLEAN_SERVICE_TICKET,
    }),
    setPrepareData: (prepareData) => ({
        type: types.SET_PREPARE_DATA,
        prepareData,
    }),
    resetPaymentForm: () => ({
        type: types.RESET_PAYMENT_FORM,
    }),
    getDebts: () => ({
        type: types.EXPIRATION_AGENDA_BILLS_REQUEST,
    }),
    getScheduledBill: ({ serviceId, userCode = "" }) => ({
        type: types.SCHEDULED_BILL_REQUEST,
        serviceId,
        userCode,
    }),
    setSelectedCompany: (selectedCompany) => ({
        type: types.SET_SELECTED_COMPANY,
        selectedCompany,
    }),
    clearCompany: () => ({
        type: types.CLEAR_COMPANY,
    }),
    getVoucherData: (operationId) => ({
        type: types.VOUCHER_REQUEST,
        operationId,
    }),
};
